import { useApisMembersUnreadNotificationCountsIndex } from "~/hooks";
import { useApiPolling } from "~/hooks";

export const useIntervalFetchNotificationCountsIndex = () => {
  const { data: fetchData, refetch } =
    useApisMembersUnreadNotificationCountsIndex({
      config: {
        useErrorBoundary: () => {
          return false;
        },
      },
    });

  useApiPolling({
    enabled: true,
    interval: 15000,
    pollingFunction: refetch,
    timeoutDuration: null,
  });

  return fetchData;
};
